module.exports = __webpack_public_path__ + "fonts/helvetica-neue-lt-pro-bold.8ee19a5e.woff2";